module.exports = __webpack_public_path__ + "static/pixel@2x-d9cd2a05e4e4ddc1d0573948f3403f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/devices/pixel@2x.png
// module id = 922
// module chunks = 115276404313086 271422636699454